module.exports = __webpack_public_path__ + "static/dash-create-bed5df14d858db37c98f3df55bc65f94.png";